import { MenuItem } from '../../../../../components/blackrock/advisor-center/_types/navigation';

export type SiteMapHeadingProps = {
	myHubDataInput?: MenuItem;
	myHubFallback: string;
};

/**
 * SiteMapHeading Component
 * Displays the Main Heading of the SiteMap with the MyHub button (or the fallback text)
 */
const SiteMapHeading: React.FC<SiteMapHeadingProps> = ({
	myHubDataInput,
	myHubFallback = 'Explore more',
}) => {
	return (
		<div className="site-map-header">
			{myHubDataInput ? (
				<a
					href={myHubDataInput.href}
					data-link-event={myHubDataInput.dataLinkEvent}
					aria-label={myHubDataInput.ariaLabel}
					target={myHubDataInput.target ?? undefined}
					data-final-url
				>
					<span
						className="my-hub-icon fa fa-angle-right"
						aria-hidden="true"
					></span>
					<span
						role="heading"
						aria-level={3}
						dangerouslySetInnerHTML={{
							__html: myHubDataInput.displayValue || '',
						}}
					></span>
				</a>
			) : (
				<span role="heading" aria-level={3} aria-label={myHubFallback}>
					{myHubFallback}
				</span>
			)}
		</div>
	);
};

export default SiteMapHeading;
